﻿var jquery = require('jquery');
require('imageMapResizer');

(function () {
    'use strict';


    var Navigation = function () {
        __registerEvents.call(this);
    };


    var __registerEvents = function () {
        jquery('map').imageMapResize();
    };


    Navigation.prototype = {
        constructor: Navigation,
    };


    if (typeof module !== 'undefined' && module.exports) {
        module.exports.Navigation = new Navigation();
    }
    else {
        window.Navigation = new Navigation();
    }


})();